import React, {useEffect} from 'react'
import styled from '@emotion/styled'
import {AnimatePresence, motion, useAnimation} from 'motion/react'

import {Button} from '@vio/atlas/Button'
import {Icon} from '@vio/atlas/Icon'

interface Props {
  onClick: () => void
  visible: boolean
}
const ScrollToBottomButtonWrapper = styled.div`
  position: absolute;
  bottom: 95px;
  left: 0;
  right: 0;
  justify-self: center;
`
export const ScrollToBottomButton = ({onClick, visible}: Props) => {
  const controls = useAnimation()
  useEffect(() => {
    controls.start(visible ? 'visible' : 'hidden')
  }, [visible])

  return (
    <ScrollToBottomButtonWrapper>
      <AnimatePresence>
        <motion.div
          variants={{
            visible: {opacity: 1, y: 0},
            hidden: {opacity: 0, y: 50}
          }}
          key="scrollToBottom"
          initial="hidden"
          animate={controls}
          transition={{
            duration: 0.15
          }}
        >
          <Button
            isRounded
            isFloating
            variant="tertiary"
            onClick={onClick}
            iconStart={<Icon name="ArrowDown" />}
            size="lg"
          />
        </motion.div>
      </AnimatePresence>
    </ScrollToBottomButtonWrapper>
  )
}
